<template lang="pug">
  .container.grid-lg
    page-title(title="Monetização" subtitle="Valor que você recebe com assinaturas, vendas e conteúdo" icon="fas fa-hand-holding-usd")
      div(slot="actions")
        .d-flex.align-center
          form-group(label="Pesquisar por mês")
            datepicker(v-model="month" input-class="form-input input-sm" type="month" format="MMMM [de] YYYY" @input="fetchBalance" :disabled-date="date => date > new Date()")
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    .columns(v-else-if="balance")
      .column.col-12.my-2(v-if="balance.status === 'opened'")
        .toast.toast-warning
          span Este relatório foi atualizado em
          b  {{ balance.updatedAt | date('DD/MM/YYYY [as] HH:mm') }}
          span  alterações feitas após esta data ainda não estão aparecendo
      .column.col-12.my-2
        cite
          | Mês de referência:
          b  {{ referenceMonth }}
      .column.col-4.col-md-6.col-sm-12.my-2
        info-card(title="Status" icon="fas fa-spell-check")
          .card-body(slot="card-body")
            .flex-centered
              .h2.text-bold.ml-1(:class="balanceStatus[balance.status].textClass") {{ balance.status | balanceStatus }}
          .card-footer.text-center(slot="card-footer")
            cite.text-small {{ balanceStatus[balance.status].description }}
      .column.col-4.col-md-6.col-sm-12.my-2
        info-card(title="Total" icon="fas fa-money-bill-alt")
          .card-body(slot="card-body")
            .flex-centered
              .h2.text-bold.ml-1.text-success {{ balance.amount | currency('R$ ') }}
          .card-footer.text-center(slot="card-footer")
            cite.text-small Este é o valor estimado dos seus ganhos em #[b {{ referenceMonth }}]
      .column.col-4.col-md-6.col-sm-12.my-2
        info-card(title="Ganhos" icon="fas fa-search-dollar")
          .card-body(slot="card-body")
            .centered
              .columns(v-for="monetization in balance.monetizations" :key="monetization.id")
                .column {{ monetization.type | monetizationType }}:
                .column.col-auto
                  b  {{ monetization.amount | currency('R$ ') }}
          .card-footer.text-center(slot="card-footer")
            cite.text-small Valor ganho em cada categoria de monetização
      .column.col-12.divider.my-2
      .column.col-12.my-2
        info-card(title="Detalhamento do balanço" icon="fas fa-clipboard-list")
          .card-body(slot="card-body")
            tabs
            router-view.details(:balance="balance")
      
      .column.col-12.my-2
        cite
          | Clique 
          router-link.text-error(:to="{ name: 'help.list', query: { search: 'Monetização' } }")  aqui
          |  para saber como o balanço é calculado

    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import { DateTime } from 'luxon'
import balances from '@/services/api/balances'
import { BALANCE_STATUS } from '@/config/constants'
import Tabs from './components/Tabs'

export default {
  components: { Tabs },
  computed: {
    referenceMonth() {
      return DateTime.fromJSDate(new Date(this.balance.month))
        .toUTC()
        .setLocale('pt-BR')
        .toLocaleString({ month: 'long', year: 'numeric' })
    },
    balanceStatus() {
      return BALANCE_STATUS
    },
  },
  data() {
    return {
      balance: null,
      loading: true,
      error: null,
      month: null,
    }
  },
  methods: {
    async fetchBalance() {
      try {
        this.error = null
        this.loading = true
        const params = { q: { month: this.month } }
        const { data } = await balances.month(params)
        this.balance = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.month = DateTime.local()
      .startOf('month')
      .toJSDate()
    this.fetchBalance()
  },
}
</script>

<style lang="stylus">
.details .content-full-height
  height auto
  padding 2rem 0
</style>

<style lang="stylus" scoped>
.centered
  display flex
  flex-direction column
  height 100%
  justify-content center

.content-full-height
  height calc(100vh - 55px - 75px - 48px - 26px)
</style>
